export type HoroscopeTabPeriod = 'daily' | 'weekly' | 'monthly' | 'yearly';

export function formatUpdatedLabel(period: HoroscopeTabPeriod, dateObj: Date = new Date()): string {
  const options: Intl.DateTimeFormatOptions = { timeZone: 'Asia/Kolkata' };

  if (period === 'daily') {
    const weekday = new Intl.DateTimeFormat('en-US', { ...options, weekday: 'long' }).format(dateObj);
    const month = new Intl.DateTimeFormat('en-US', { ...options, month: 'long' }).format(dateObj);
    const day = new Intl.DateTimeFormat('en-US', { ...options, day: 'numeric' }).format(dateObj);
    const year = new Intl.DateTimeFormat('en-US', { ...options, year: 'numeric' }).format(dateObj);
    return `Updated ${weekday}, ${month} ${day}, ${year}`;
  }

  if (period === 'weekly') {
    return 'Updated this week';
  }

  if (period === 'monthly') {
    const month = new Intl.DateTimeFormat('en-US', { ...options, month: 'long' }).format(dateObj);
    const year = new Intl.DateTimeFormat('en-US', { ...options, year: 'numeric' }).format(dateObj);
    return `Updated for ${month} ${year}`;
  }

  if (period === 'yearly') {
    const year = new Intl.DateTimeFormat('en-US', { ...options, year: 'numeric' }).format(dateObj);
    return `Updated for ${year}`;
  }

  return `Updated ${period} forecast`;
}
